import { Component, OnInit } from '@angular/core';
import { MainserviceService } from './../mainservice.service';
import { Router } from "@angular/router";

@Component({
  selector: 'app-shops',
  templateUrl: './shops.component.html',
  styleUrls: ['./shops.component.scss']
})

export class ShopsComponent implements OnInit {
  shopFilter:any = { name: ''}
  p: number = 1; 

  shops:any;

  constructor(private mainServ: MainserviceService,
              private router:Router
            ) { }

  ngOnInit() {
    this.mainServ.getShops().subscribe(data => {
      this.shops = data
  });
    }

}




// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/shops/shops.component.ts